export const SERVICE_KEYS = {
  // Repositories
  SESSION_REPOSITORY: "SESSION_REPOSITORY",
  USER_REPOSITORY: "USER_REPOSITORY",
  
  // API Services
  SESSION_API: "SESSION_API",
  USER_API: "USER_API",
  
  // Use Cases
  GET_MY_SESSIONS: "GET_MY_SESSIONS",
  OPEN_SESSION: "OPEN_SESSION",
  CLOSE_SESSION: "CLOSE_SESSION",
  
  // ViewModels
  DASHBOARD_VIEW_MODEL: "DASHBOARD_VIEW_MODEL",
  MY_SHIFTS_VIEW_MODEL: "MY_SHIFTS_VIEW_MODEL",
  AUTH_VIEW_MODEL: "AUTH_VIEW_MODEL",
} as const;

export type ServiceKey = typeof SERVICE_KEYS[keyof typeof SERVICE_KEYS];
